"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailsOverviewPage = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const email_overview_page_constants_1 = require("./email-overview-page.constants");
const errors_copy_1 = require("@/common/errors.copy");
const common_1 = require("@/emails/common");
const layout_1 = require("@/common/components/layout");
const AccountContext_1 = require("contexts/AccountContext");
const EmailsOverviewPage = () => {
    const { account } = (0, AccountContext_1.useAccount)();
    const { emailTypes, emailTypesLoading, emailTypesError } = (0, common_1.useEmailTypesContext)();
    const renderTitleMetadata = () => {
        return (react_1.default.createElement(polaris_1.Text, { as: 'span', tone: 'subdued', variant: 'bodySm' },
            "Transactional email messages are billed at a separate per message cost. Volume discounts available. See pricing and learn more\u00A0",
            react_1.default.createElement(polaris_1.Link, { removeUnderline: true, target: '_blank', url: 'https://gomalomo.com/pricing' }, "here"),
            "."));
    };
    return (react_1.default.createElement(layout_1.PolarisPage, { fullWidth: true, title: email_overview_page_constants_1.emailCopy.pageTitle, titleMetadata: renderTitleMetadata() },
        react_1.default.createElement(polaris_1.Layout, null,
            renderRequiredTPLayoutSection(),
            react_1.default.createElement(polaris_1.Layout.Section, null, renderCustomizeSection()),
            react_1.default.createElement(polaris_1.Layout.Section, null,
                react_1.default.createElement(polaris_1.Card, null, renderEmailSection())))));
    function renderRequiredTPLayoutSection() {
        if (account === null || account === void 0 ? void 0 : account.defaultTrackingPageUrl) {
            return null;
        }
        return (react_1.default.createElement(polaris_1.Layout.Section, null,
            react_1.default.createElement(polaris_1.Banner, { action: {
                    content: email_overview_page_constants_1.emailCopy.requiredTrackingPageButtonText,
                    url: '/account',
                    id: 'set-default-tp-url-button'
                }, icon: polaris_icons_1.InfoIcon, tone: 'critical' },
                react_1.default.createElement("p", { id: 'require-default-tracking-page-banner' }, email_overview_page_constants_1.emailCopy.requiredTrackingPageBannerHeader))));
    }
    function renderCustomizeSection() {
        return (react_1.default.createElement(polaris_1.Card, null,
            react_1.default.createElement(polaris_1.Text, { as: 'h2', id: 'customize-email-templates-header', variant: 'headingMd' }, email_overview_page_constants_1.emailCopy.customizeEmailTemplatesHeader),
            react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '200' },
                react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' }, email_overview_page_constants_1.emailCopy.customizeEmailDesc)),
            react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '300' },
                react_1.default.createElement(polaris_1.Button, { accessibilityLabel: email_overview_page_constants_1.emailCopy.customizeEmailTemplatesHeader, id: 'customize-email-templates-button', url: '/transactional_emails/config' }, email_overview_page_constants_1.emailCopy.customizeEmailTemplatesHeader))));
    }
    function renderEmailSection() {
        if (emailTypesLoading) {
            return (react_1.default.createElement(polaris_1.BlockStack, { align: 'center', inlineAlign: 'center' },
                react_1.default.createElement(polaris_1.Spinner, { accessibilityLabel: 'Loading email template types...', size: 'large' })));
        }
        if (emailTypesError) {
            return renderServerErrorBanner();
        }
        return (react_1.default.createElement(polaris_1.BlockStack, { gap: '300' },
            react_1.default.createElement(polaris_1.Text, { as: 'h2', id: 'malomo-emails-header', variant: 'headingMd' }, email_overview_page_constants_1.emailCopy.malomoEmailsHeader),
            react_1.default.createElement(polaris_1.Box, { paddingBlockEnd: '400' },
                react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' },
                    "Customize each of the email templates below and switch them to live when you're ready for your customers to receive them. Make sure to",
                    ' ',
                    react_1.default.createElement(polaris_1.Link, { id: 'disable-shopify-link', removeUnderline: true, target: '_blank', url: email_overview_page_constants_1.emailConstants.disableEmailsLink }, "disable your Shopify emails"),
                    ' ',
                    "before setting these live.")),
            renderEmailTemplateList()));
    }
    function renderEmailTemplateList() {
        if (!emailTypes.length) {
            return renderServerErrorBanner();
        }
        return emailTypes.map((emailTemplate, idx) => {
            const lastListItem = emailTypes.length - 1 === idx;
            return renderEmailTemplateItem(emailTemplate, lastListItem);
        });
    }
    function renderEmailTemplateItem(emailTemplate, lastListItem) {
        return (react_1.default.createElement("div", { id: `${emailTemplate.slug}-list-item`, key: emailTemplate.slug },
            react_1.default.createElement(polaris_1.BlockStack, null,
                react_1.default.createElement(polaris_1.BlockStack, { align: 'center', gap: '400', inlineAlign: 'stretch' },
                    react_1.default.createElement(polaris_1.InlineStack, { align: 'start', gap: '300' },
                        react_1.default.createElement(polaris_1.Box, { minWidth: '280px' },
                            react_1.default.createElement(polaris_1.InlineStack, { align: 'start', gap: '300' },
                                react_1.default.createElement(polaris_1.Link, { url: `/transactional_emails/${emailTemplate.slug}` }, emailTemplate.name),
                                emailTemplate.shopifyPlus && (react_1.default.createElement(polaris_1.Badge, { tone: 'warning' }, "Shopify Plus only")))),
                        react_1.default.createElement("div", { style: { flexGrow: '1' } },
                            react_1.default.createElement(polaris_1.InlineStack, { align: 'space-between', blockAlign: 'center', gap: '300' },
                                react_1.default.createElement(polaris_1.Text, { as: 'p' }, emailTemplate.description),
                                renderStatusBadge(emailTemplate.active)))),
                    !lastListItem && react_1.default.createElement(polaris_1.Divider, null)))));
    }
    function renderStatusBadge(active) {
        if (active) {
            return react_1.default.createElement(polaris_1.Badge, { tone: 'success' }, "Live");
        }
        return react_1.default.createElement(polaris_1.Badge, null, "Inactive");
    }
    function renderServerErrorBanner() {
        return (react_1.default.createElement("div", { id: 'malomo-emails-error' },
            react_1.default.createElement(polaris_1.Banner, { title: 'Cannot load email templates', tone: 'critical' }, errors_copy_1.errorsCopy.fetchError)));
    }
};
exports.EmailsOverviewPage = EmailsOverviewPage;
